import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const AdminLogin = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { adminLogin } = useAdminAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(form.email, form.password);
      navigate('/admin');
    } catch (err) {
      toast.error(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <img src="/logo.jpg" alt="Qaya KW" height="64" style={{ marginBottom: 24 }} />
        <h2>Admin Panel</h2>
        <p>Sign in to manage your store</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input type="email" className="form-control" value={form.email}
              onChange={e => setForm({...form, email: e.target.value})} required autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input type="password" className="form-control" value={form.password}
              onChange={e => setForm({...form, password: e.target.value})} required />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width:'100%', padding:14, marginTop:8 }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In to Admin'}
          </button>
        </form>
      </div>
      <style>{`
        .admin-login-page {
          min-height: 100vh; display: flex; align-items: center; justify-content: center;
          background: var(--olive-dark); padding: 20px;
        }
        .admin-login-card {
          background: white; border-radius: var(--radius-lg); padding: 48px 40px;
          width: 100%; max-width: 400px; text-align: center; box-shadow: var(--shadow-lg);
        }
        .admin-login-card h2 { font-family: var(--font-serif); margin-bottom: 6px; }
        .admin-login-card > p { color: var(--text-muted); margin-bottom: 28px; font-size: 0.9rem; }
        .admin-login-card .form-group { text-align: left; }
      `}</style>
    </div>
  );
};

export default AdminLogin;
